import CampaignSocialActionSettingsModal from './CampaignSocialActionSettingsModal';

export default CampaignSocialActionSettingsModal;
